import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { CheckCircle } from "@phosphor-icons/react";

export default function AdminUsers() {
    const [users, setUsers] = useState([]);

    const load = () =>
        api.get("/admin/users").then(({ data }) => setUsers(data));
    useEffect(() => {
        load();
    }, []);

    const verify = async (uid) => {
        await api.put(`/admin/users/${uid}/verify`);
        toast.success("Verified");
        load();
    };

    const credits = async (uid, delta) => {
        await api.put(`/admin/users/${uid}/credits?delta=${delta}`);
        toast.success(
            `${delta > 0 ? "Added" : "Removed"} ${Math.abs(delta)} credits`,
        );
        load();
    };

    return (
        <div className="max-w-7xl mx-auto px-6 py-10" data-testid="admin-users">
            <div className="relative overflow-hidden mb-6 p-6 g-emerald text-white shadow-glow-emerald">
                <div className="absolute -top-10 -right-10 w-48 h-48 bg-white/10 rounded-full blur-3xl" />
                <div className="relative">
                    <div className="text-xs font-mono uppercase tracking-widest text-white/70">
                        Admin
                    </div>
                    <h1 className="font-display font-black text-4xl tracking-tighter">
                        Users
                    </h1>
                </div>
            </div>

            <div className="card-surface overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-zinc-50 border-b">
                        <tr className="text-xs uppercase tracking-widest text-zinc-500">
                            <th className="text-left p-3">Name</th>
                            <th className="text-left p-3">Email</th>
                            <th className="text-left p-3">Mobile</th>
                            <th className="text-left p-3">Organization</th>
                            <th className="text-left p-3">Role</th>
                            <th className="text-left p-3">Credits</th>
                            <th className="text-left p-3">Verified</th>
                            <th className="text-right p-3">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((u) => (
                            <tr
                                key={u.id}
                                className="border-b border-zinc-100"
                                data-testid={`user-row-${u.id}`}
                            >
                                <td className="p-3 font-medium">{u.name}</td>
                                <td className="p-3 font-mono text-xs">
                                    {u.email}
                                </td>
                                <td className="p-3 font-mono text-xs">
                                    {u.mobile_no || "—"}
                                </td>
                                <td className="p-3 text-xs">
                                    {u.organization || "—"}
                                </td>
                                <td className="p-3">
                                    <span
                                        className={`text-xs font-bold uppercase ${u.role === "admin" ? "text-blue-600" : "text-zinc-700"}`}
                                    >
                                        {u.role}
                                    </span>
                                </td>
                                <td className="p-3 font-mono">
                                    {u.credits_remaining ?? 0}
                                </td>
                                <td className="p-3">
                                    {u.is_verified ? (
                                        <span className="text-green-600 flex items-center gap-1 text-xs">
                                            <CheckCircle
                                                size={13}
                                                weight="fill"
                                            />{" "}
                                            Yes
                                        </span>
                                    ) : (
                                        <span className="text-xs text-zinc-500">
                                            —
                                        </span>
                                    )}
                                </td>
                                <td className="p-3 text-right space-x-1">
                                    {!u.is_verified && (
                                        <button
                                            className="btn-ghost text-xs"
                                            onClick={() => verify(u.id)}
                                            data-testid={`verify-${u.id}`}
                                        >
                                            Verify
                                        </button>
                                    )}
                                    <button
                                        className="btn-ghost text-xs"
                                        onClick={() => credits(u.id, 50)}
                                        data-testid={`credit-add-${u.id}`}
                                    >
                                        +50
                                    </button>
                                    <button
                                        className="btn-ghost text-xs"
                                        onClick={() => credits(u.id, -50)}
                                        data-testid={`credit-sub-${u.id}`}
                                    >
                                        −50
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
